<template>
  <section class="page-user-my-courses">
    <div class="banner-my-courses pt-5">
      <div class="container h-100 d-flex align-items-end">
        <div class="tab-nav-master-mobile">
          <div class="tab-scroll text-center d-flex flex-row justify-content-center">
            <router-link
              to="/v1/learning"
              class="d-inlin-block px-md-3 py-md-2 px-1 py-1 font-14"
              exact
            >لیست دوره ها</router-link>
            <router-link
              to="/v1/collections"
              class="d-inlin-block px-md-3 py-md-2 px-1 py-1 font-14"
            >لیست کالکشن های</router-link>
            <router-link
              to="/v1/collections"
              class="d-inlin-block px-md-3 py-md-2 px-1 py-1 font-14"
            >لیست علاقه مندی ها</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'page-user-my-courses'
}
</script>

<style lang="less">
@import (reference) "../assets/css/variable.less";
.page-user-my-courses {
  .box-clear;
  .banner-my-courses {
    header {
      h1 {
        color: @withe;
      }
      p {
        color: @withe;
      }
    }
    height: 150px;
    background: url("../assets/img//goran-ivos-343495-unsplash.jpg") no-repeat
      center;
    background-attachment: fixed;
    background-size: cover;
    position: relative;
    z-index: 0;
    &:before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.534);
    }
  }
  .tab-nav-master-mobile {
    overflow: hidden;
    overflow-x: auto;
    overflow-y: hidden;
    z-index: 2;
    a {
      min-width: 160px;
      background: #fff;
      color: @primaryTextColor;
      line-height: 45px;
      padding: 10px 0;
      .line-hover;
    }
    .router-link-active {
      .line;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my-courses.vue